module.exports = __webpack_public_path__ + "static/fonts/CenturyGothic-Bold.6ed2e88.ttf";